export const SalesEndpoints = {
    salesTransactions: () => '/sales/transactions',
};
